interface AlertModal {
  id: string;
  title: string;
  content: string;
  onConfirm?: () => void;
}
let modals: AlertModal[] = []; // 현재 등록된 모달 리스트
const listeners = new Set<() => void>(); // 상태 변경 리스너

export const modalStore = (() => {
  // 상태 변경 알림
  const notify = () => {
    listeners.forEach((listener) => listener());
  };

  return {
    // 모달 등록
    register(modal: AlertModal) {
      modals = [...modals, modal];
      notify();
    },
    // 모달 제거
    unregister(modalId: string) {
      modals = modals.filter((modal) => modal.id !== modalId);
      notify();
    },
    // 현재 상태 가져오기
    getSnapshot() {
      return modals; // 배열 복사
    },
    // 상태 변경 구독
    subscribe(listener: () => void) {
      listeners.add(listener);
      return () => listeners.delete(listener); // 구독 해제
    },
  };
})();
